import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 10\" id=\"icon-minus\"><g clip-path=\"url(#icon-minus_a)\"><path d=\"M-.46 5.51V3.77h9.4v1.74h-9.4Z\" fill=\"#000\" /></g><defs><clipPath id=\"icon-minus_a\"><path fill=\"#fff\" transform=\"translate(.54 .77)\" d=\"M0 0h8.46v8.46H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol